import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Router } from'@angular/router';
import swal from 'sweetalert2';
import * as _ from "lodash";
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { UserService } from 'app/users/shared/user.service';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css'],
  animations: [fadeInOutTranslate],
  providers:[AngularFireDatabase, NotificationToastService]
})
export class BranchesComponent implements OnInit {
  myForm: FormGroup;
  submitted: boolean;
  error: String = '';
  hasError: boolean;
  brachesList: AngularFireList<any>
  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  lastId = 201900000001;
  @ViewChild('deleteModal') deleteModal;
  errorMessage =null;
  constructor(public af: AngularFireAuth,public db:AngularFireDatabase,private router: Router, private nf:NotificationToastService, private ls:LogisticsService, private us:UserService) {
    this.initializeForm();
  }

  ngOnInit() {
    var x = this.getAllBranches();
    x.snapshotChanges().subscribe(item=>{
      this.data = [];
      item.forEach(element =>{
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.data.push(y);    
      });
    });
    this.getAccountKey();
  }


  getAccountKey() {
    const d = this.db.list('/financeExpenseCat', ref => ref.orderByKey().limitToLast(1)).valueChanges();
    d.subscribe(data => {
      data.forEach(d => {
        var year = (String(d["id"])).substring(0, 4);
        var date = new Date();
        var currentYear = date.getFullYear();
        if (year == String(currentYear)) {
          this.lastId = parseInt(d["id"]) + 1;
        } else {
          this.lastId = parseInt(currentYear + "00000000");
        }
      });
    });
  }

  initializeForm()
  {
    let name = new FormControl('', Validators.required);
    let address = new FormControl('', Validators.required);
    let lat = new FormControl('', Validators.required);
    let lng = new FormControl('', Validators.required);
    let code = new FormControl('', Validators.required);
    let phone = new FormControl('', Validators.required);
    this.myForm = new FormGroup({
      name:name,
      address:address,
      lat:lat,
      lng:lng,
      code:code,
      phone: phone,
    });
    this.myForm.reset();
    this.myForm.controls["code"].setValue('+966');
  }
  phone_error:boolean = false;
  onSubmit() {
    this.hasError = false;
    this.submitted = true;
    this.phone_error = false;
    var phone = this.myForm.value.phone;
    if(phone.length != this.maxLength)
    {
      this.phone_error = true;
      return;
    }
    else if(this.myForm.valid) {
      //var currentKey = firebase.database().ref("branches").push().getKey();
      var usersRef = firebase.database().ref("branches");
      usersRef.push({ 
        name: this.myForm.value.name,
        address: this.myForm.value.address,
        lat: this.myForm.value.lat,
        lng: this.myForm.value.lng,
        code: this.myForm.value.code,
        phoneNumber: this.myForm.value.phone,
        status: "active",
        created_at: new Date(),
        accountId:this.lastId
      }).then(
        (success) => {
          this.createAccount(this.myForm.value.name,this.lastId,success.key);
          this.hasError = true;
          this.submitted = false;
          this.myForm.reset();
          this.myForm.controls["code"].setValue('+966');
          this.nf.addToast({title:'Registration Success', msg:'New Branch has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        });
    } 
  }
  
  createAccount(name, id,key) {
    firebase.database().ref('financeExpenseCat').child(id).set({
      amount: "0",
      categoryDescription: "",
      categoryName: name,
      categoryType: '',
      branchId: key,
      id:id
    });
  }
  delete(branchId,rowData) {
    this.errorMessage = null;
    this.checkBranchHasShipmentsAssigned(branchId,rowData);
  }
  checkBranchHasShipmentsAssigned(branchId,rowData)
  {
    this.ls.getAllShipmentsAssignedTobranch(branchId).once("value").then((data)=>{
      if(data.val()==null)
      {
        this.us.getAllUsersOfBranch(branchId).once("value").then((userData)=>{
          if(userData.val()==null)
          {
            swal({
              title: 'Are you sure?',
              text: "You won't be able to revert this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
            }).then(() => {
              this.db.object('/branches/'+branchId).remove();
              this.db.object('/financeExpenseCat/'+rowData.accountId).remove();
              swal({
                title:'Deleted!',
                text: 'Your file has been deleted.',
                type: 'success'
              })
            }).catch(swal.noop);
          }
          else
          {
            this.errorMessage = "Branch has "+userData.numChildren()+" users";
            this.deleteModal.show();
          }
        });
      }
      else
      {
        this.errorMessage = "Branch has "+data.numChildren()+" shipments";
        this.deleteModal.show();
      }
    });
  }
  view(id)
  {
    this.router.navigate(['/manage-branch'], { queryParams : {key: id, from: 'branch'}  });
  }

  getAllBranches()
  {
    this.brachesList = this.db.list("branches");
    return this.brachesList;
  }
  refresh()
  {
    this.sortBy = "";
    this.filterQuery = "";
  }
  maxLength: number =9;
  onChangeCountry(e)
  {
    this.phone_error = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
  onChange(event, id) {
    if(event)
    {
      this.brachesList.update(id,{ 
        status: "active"
      }).then(
        (success) => {
          //console.log("status updated");
        });
    }
    else{
      this.brachesList.update(id,{ 
        status: "inactive"
      }).then(
        (success) => {
          //console.log("status updated");
        });
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/branches/branches.component.ts